export const SALEOR_AUTH_PLUGIN_ID = "_saleorAuthPluginId";
export const SALEOR_REFRESH_TOKEN = "_saleorRefreshToken";
// The CSRF token is safe to persist: on its own it grants nothing. The refresh
// token it pairs with lives in the backend's httpOnly `refreshToken` cookie,
// which JavaScript cannot read — so an XSS payload cannot exfiltrate a usable
// session. Silent re-auth after a reload sends this CSRF token + the cookie.
export const SALEOR_CSRF_TOKEN = "_saleorCSRFToken";
